import { css } from '@emotion/react';
import { Box, desktopFirstMediaQuery, Text } from '@inflearn/ds-react';
import React from 'react';

type Props = {
  body: string;
  speakerName: string;
  speakerGroup: string;
  profileImage: string;
};

const profileWidth = 54;

const SessionContent = ({ speakerName, speakerGroup, profileImage, body }: Props) => {
  return (
    <Box component="section">
      <Box css={styleSessionDetailSpeaker}>
        <Box component="figure">
          <img
            src={profileImage}
            alt={`${speakerName}님의 프로필 사진`}
            css={styleSessionDetailThumbnail}
          />
        </Box>
        <Box>
          <Text
            weight="bold"
            color="gray.9"
            size={20}
            css={{
              [desktopFirstMediaQuery.mobile]: {
                fontSize: 18
              }
            }}>
            {speakerName}
          </Text>
          <Text weight="medium" color="gray.9" size={14}>
            {speakerGroup}
          </Text>
        </Box>
      </Box>
      <div dangerouslySetInnerHTML={{ __html: body }} />
    </Box>
  );
};

const styleSessionDetailSpeaker = css({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px',
  [desktopFirstMediaQuery.mobile]: {
    marginBottom: '12px'
  }
});

const styleSessionDetailThumbnail = css({
  marginRight: '8px',
  width: `${profileWidth}px`,
  height: `${profileWidth}px`,
  borderRadius: '500px',
  objectFit: 'cover'
});

export default SessionContent;
